import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import './Auth.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const resolvePostLoginRoute = () => {
    try {
      const last = sessionStorage.getItem('aot_last_route');
      if (last && !last.startsWith('/login') && !last.startsWith('/register')) {
        return last;
      }
    } catch (_) {}
    return '/';
  };

  useEffect(() => {
    if (!isAuthenticated) return;
    navigate(resolvePostLoginRoute(), { replace: true });
  }, [isAuthenticated, navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(formData.email, formData.password);
      if (result.success) {
        try {
          localStorage.setItem('aot_auth_event', String(Date.now()));
        } catch (_) {}
        navigate(resolvePostLoginRoute(), { replace: true });
      } else {
        setError(result.error);
      }
    } catch (error) {
      setError('Произошла ошибка. Попробуйте снова.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Вход в систему</h2>
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Пароль:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              disabled={loading}
            />
            {!!error && (
              <div style={{ marginTop: 10, textAlign: 'right' }}>
                <Link to="/forgot-password" style={{ fontSize: 14 }}>
                  Забыли пароль?
                </Link>
              </div>
            )}
          </div>

          <button type="submit" disabled={loading}>
            {loading ? 'Вход...' : 'Войти'}
          </button>
        </form>

        <p className="auth-link">
          Нет аккаунта? <Link to="/register">Регистрация</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
